import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import CSSTransition from "react-transition-group/cjs/CSSTransition";

const Notif = (props) => {

    const getImage = () => {
        switch (props.type) {
            case "danger":
                return "fa-times-circle";
            case "info": {
                return "fa-info-circle";
            }
            case "success": {
                return "fa-check"
            }
            case "warning": {
                return "fa-exclamation";
            }
            default :
                return "";
        }

    }

    return (

        <CSSTransition in={props.isOpen}
                       mountOnEnter
                       unmountOnExit
                       appear
                       classNames={'notif__visible'}
                       timeout={{enter: props.transitionEnterTimeout, exit: props.transitionLeaveTimeout}}>
            <div className={`alert alert-${props.type} shadow d-flex flex-row flex-wrap w-100 justify-content-between`}>
                <div className='d-flex flex-wrap flex-row align-items-center justify-content-start' style={{width: '96%'}}>
                    <i className={'fa ' + getImage() + ' fa-lg'} style={{float: 'left'}}/>
                    <p className='ml-3 d-inline-block' style={{marginBottom: '2px', width: '96%'}}>
                        {Array.isArray(props.message)
                            ? props.message.map((msg, idx) =>
                                typeof msg === 'string'
                                    ? msg.split('\n').map((line, i, arr) => (
                                        <React.Fragment key={i}>
                                            {line}
                                            {i < arr.length - 1 && <br />}
                                        </React.Fragment>
                                      ))
                                    : msg
                              )
                            : typeof props.message === 'string'
                                ? props.message.split('\n').map((line, i, arr) => (
                                    <React.Fragment key={i}>
                                        {line}
                                        {i < arr.length - 1 && <br />}
                                    </React.Fragment>
                                  ))
                                : props.message
                        }
                    </p>
                </div>

                <span onClick={() => props.toggle(props.id)} style={{cursor: 'pointer', position: 'relative', top: 0}}>
                    <i className={`fa fa-times text-${props.type}`}/>
                </span>

            </div>
        </CSSTransition>
    )
};

const mapStateToProps = state => {
    return {
        notifications: state.get ? state.get('notifs') : state.notifs
    }
};

Notif.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    message: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.element, PropTypes.object]),
    type: PropTypes.oneOf([
        'success',
        'info',
        'warning',
        'danger',
    ]).isRequired,
    onActionClick: PropTypes.func,
    actionLabel: PropTypes.string,
    toggle: PropTypes.func
};

Notif.defaultProps = {
    type: 'info'
};

export default connect(mapStateToProps)(Notif);


